import { ref } from '@nuxtjs/composition-api';
import { setAdformSegments } from '@/modules/tracking/scripts/adform';
import { generatePPID } from '../utils/utils';

export const initializeGPT = (adTags, options, adConfig, isMobile, user) => {
  const isGPTLoaded = ref(false);
  const isCriteoLoaded = ref(false);
  const isCriteoNeeded = options?.withCriteo || adConfig.value?.mode?.scripts?.includes('Adblock');
  if (!isGPTLoaded.value) {
    adTags.script.push(
      {
        hid: 'gpt',
        src: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
        async: true,
        callback: () => {
          // console.log('LOADED GPT');
          isGPTLoaded.value = true;
        },
      },
      {
        hid: 'gptInit',
        innerHTML: `
          window.googletag = window.googletag || {cmd: []};
          googletag.cmd.push(function() {
            googletag.pubads().enableSingleRequest();
            googletag.pubads().collapseEmptyDivs();
            googletag.pubads().disableInitialLoad();
          })
        `,
      }
    );
  }
  if (isCriteoNeeded && !isCriteoLoaded.value) {
    adTags.script.push(
      {
        hid: 'criteo',
        src: 'https://static.criteo.net/js/ld/publishertag.js',
        async: true,
        callback: () => {
          // console.log('LOADED CRITEO');
          isCriteoLoaded.value = true;
        },
      },
      {
        hid: 'criteoInit',
        innerHTML: `
          window.Criteo = window.Criteo || {};
          window.Criteo.events = window.Criteo.events || [];
        `,
      }
    );
  }
  if (process.client) {
    setAdformSegments();
    adTags.script.push({
      hid: 'gptInit',
      innerHTML: `
          window.googletag = window.googletag || {cmd: []};
          googletag.cmd.push(function() {
            googletag.pubads().setPublisherProvidedId('${generatePPID(user)}');
            googletag.enableServices();
          })
        `,
    });
  }
};
